<template>
	<main class="sub">
		<div class="content">
			<v-image :src="data.companySpecialPicture" width="660px" height="440px"></v-image>
			<!-- <img :src="data.companySpecialPicture"> -->
			<div class="context">
				<div class="ident"><span></span><span></span></div>
				<div v-html="data.companySpecialContext"></div>
			</div>
		</div>
	</main>
</template>
<style lang="less" scoped>
@red: #e60012;

.sub {
	width: 1200px;
	margin: 0 auto;

	.content {
		display: flex;
		position: relative;

		img {
			width: 660px;
			height: 440px;
			object-fit: cover;
		}

		.context {
			position: absolute;
			top: 30px;
			left: 469px;
			flex: 1;
			padding: 63px 30px 38px 24px;
			display: flex;
			width: 731px;
			height: 380px;
			background-color: #EFEFEF;
			color: #353535;
			font-size: 14px;
			line-height: 24px;
			text-align: left;
			overflow: auto;

			.ident {
				display: flex;
				position: absolute;
				top: 29px;
				left: 25px;

				span {
					width: 48px;
					height: 4px;
					background-color: #353535;

					&:not(:last-child) {
						background-color: @red;
					}

				}
			}
		}
	}

}

@media screen and (max-width: 1360px) {
	.sub {
		width: auto;
	}

	.content {
		position: relative;
		width: 100%;
		padding: 20px;
		overflow: hidden;
		display: flex;
		flex-direction: column;

		.v-image {
			width: 100% !important;
			height: auto !important;

			/deep/ img {
				width: 100% !important;
				height: auto !important;
			}
		}

		.context {
			position: relative !important;
			left: 30px !important;
			top: 0 !important;
			right: auto !important;
			bottom: auto !important;
			padding: 20px !important;
			width: calc(100% - 60px) !important;
			height: auto !important;
			margin-top: -22%;
			box-shadow: 0 0 5px rgba(0, 0, 0, .12);
		}
	}
}
</style>
<script>
export default {
	data() {
		return {
			data: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.id
		}
	},
	methods: {
		getSpecial() {
			let that = this;
			ajax.call(this, {
				url: "/company/special/details",
				data: {
					companyId: that.id
				},
				s(res) {
					if (res.data) {
						that.data = res.data
					} else {
						that.data = {}
					}
				}
			});
		},

	},
	mounted() {
		this.getSpecial();
	},
	watch: {
		"$root.language"() {
			this.getSpecial();
		},
		id() {
			this.getSpecial();
		}
	}
}
</script>